import './mainSchedePageSelect.css'
import ListSchede from './subElements/listSchede'

const SchedePageSelect = ({ metaDataLink }) => {
    return <ListSchede
        metaDataLink={metaDataLink}
    />
}

export default SchedePageSelect